import React, { CSSProperties } from 'react';
import times from 'lodash/times';
import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

export interface StarRatingProps {
	rating: number;
	onRate?: (rate: number) => void;
	className?: string;
	style?: CSSProperties;
	ariaTranslations?: AriaTranslations;
}

interface AriaTranslations {
	describedById?: string;
	labelOne?: string;
	labelTwo?: string;
}

const StarRating: React.FC<StarRatingProps> = ({ rating = 0, onRate, className, style, ariaTranslations }) => {
	return (
		<div className={classNames('star-rating', className)} style={style}>
			{times(5, index => {
				const buttonRating = index + 1;
				const starActive = buttonRating <= rating;
				const className = classNames('star-icon', { active: starActive, 'star-icon-clickable': !!onRate });
				const onClick = () => {
					onRate?.(buttonRating);
				};
				const starAriaLabel = `${ariaTranslations?.labelOne || ''} ${buttonRating} ${
					ariaTranslations?.labelTwo || ''
				}`;
				return (
					<button
						key={index}
						className={className}
						onClick={onClick}
						role="checkbox"
						aria-label={starAriaLabel}
						aria-describedby={ariaTranslations?.describedById || ''}
						aria-checked={starActive}
					>
						<BringgIcon iconName={BringgFontIcons.Star} aria-hidden="true" />
					</button>
				);
			})}
		</div>
	);
};

export default StarRating;
